import { combineReducers } from 'redux';

import alert from './alert';
import loader from './loader';
import breadcrumb from './breadcrumb';

import auth from './auth';
import dashboard from './dashboard';
import locatarios from './locatarios';
import clientes from './clientes';
import usuarios from './usuarios';
import citas from './citas';
import reportes from './reportes';
import configuracion from './configuracion';

export default combineReducers({
    alert, loader, breadcrumb, auth, dashboard, locatarios, clientes, usuarios, citas, reportes, configuracion
});